import { HttpBackend, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TitleBarComponent, DialogComponent, ToastComponent, SortPipe, SafeHtmlPipe, InputComponent, ButtonComponent, PickListComponent, LoadingComponent } from 'mis-component-library';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { webSocket } from 'rxjs/webSocket';
import { AppRoutingModule, DEV_LOGIN_ROUTE_CONFIG } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiIntecerceptorService } from './services/api-interceptor/api-intecerceptor.service';
import { ENV, getEnv } from 'src/providers/environment.provider';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TenantService } from './services/tenant/tenant.service';
import { WebSocketMessage, WebSocketSubject } from 'rxjs/internal/observable/dom/WebSocketSubject';
import { WebSocketSubscription } from 'src/types/web-socket-subscription';
import { LoginModule } from 'login';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    ButtonComponent,
    InputComponent,
    ReactiveFormsModule,
    LoadingComponent,
    SortPipe,
    SafeHtmlPipe,
    TitleBarComponent,
    DialogComponent,
    ToastComponent,
    PickListComponent,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LoginModule.forRoot({
      licenseServerUrl: environment.licenseServerURL,
      // If the environment does not specifiy the login host, this register the login page components to be hosted itself
      pathConfig: !environment.loginHost ? DEV_LOGIN_ROUTE_CONFIG : undefined
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    BrowserAnimationsModule
  ],
  providers: [
    { provide: ENV, useFactory: getEnv },
    { provide: HTTP_INTERCEPTORS, useClass: ApiIntecerceptorService, multi: true },
    {
      provide: 'WEBSOCKET',
      useFactory: async (tenantService: TenantService): Promise<WebSocketSubject<WebSocketMessage | WebSocketSubscription>> => {
        const url = await tenantService.getWebsocketUrl();
        return webSocket(url);
      },
      deps: [TenantService]
    },
    //{ provide: APP_INITIALIZER, useFactory: initializeApp, deps: [HttpClient], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// function initializeApp(http: HttpClient): () => Promise<void> {
//   return async () => {
//     const value = await firstValueFrom(http.get<ValidationResponse>('validation'));
//     console.log('Validation: ', value.valid);
//     console.log('Errors: ', value.errors);
//   };
// }

// AoT requires an exported function for factories
export function HttpLoaderFactory(handler: HttpBackend): TranslateLoader {
  return new MultiTranslateHttpLoader(handler, [
    { prefix: './assets/i18n/', suffix: '.json' },
    { prefix: './assets/i18n/framework/', suffix: '.json' },
    { prefix: './assets/i18n/pages/login/', suffix: '.json' },
    { prefix: './assets/i18n/pages/analyse/', suffix: '.json' },
    { prefix: './assets/i18n/pages/job-history/', suffix: '.json' },
    { prefix: './assets/i18n/pages/document-types/', suffix: '.json' },
    { prefix: './assets/i18n/pages/edit-document-type/', suffix: '.json' },
    { prefix: './assets/i18n/pages/not-found/', suffix: '.json' },
    { prefix: './assets/i18n/pages/bulk-upload/', suffix: '.json' }
  ]);
}